export default __webpack_public_path__ + "static/media/lynn-artworkinfo2.d4bb2065.png";